import React from "react";

export default function UserGuideTileHomeIcon({ size = 47 }) {
  const gid = React.useId().replace(/:/g, "");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={gid}
          x1="0"
          y1="0"
          x2="47"
          y2="47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8E2FF" />
          <stop offset="1" stopColor="#721AF0" />
        </linearGradient>
      </defs>
      <rect width="46.75" height="46.75" rx="23.375" fill={`url(#${gid})`} />
      <path
        d="M25.3083 12.0439C24.7673 11.6119 24.0825 11.375 23.375 11.375C22.6675 11.375 21.9827 11.6119 21.4417 12.0439L12.4417 19.2378C12.1076 19.5045 11.8391 19.8371 11.6548 20.2124C11.4706 20.5877 11.3751 20.9966 11.375 21.4104V33.1644C11.375 34.3847 12.4203 35.375 13.7083 35.375H17.7083C18.3272 35.375 18.9207 35.1421 19.3582 34.7275C19.7958 34.313 20.0417 33.7507 20.0417 33.1644V28.1079C20.0417 27.2489 20.7643 26.5516 21.6643 26.5289H25.0857C25.52 26.5398 25.9327 26.7109 26.2358 27.0058C26.5389 27.3008 26.7085 27.6962 26.7083 28.1079V33.1644C26.7083 34.3847 27.7537 35.375 29.0417 35.375H33.0417C33.6605 35.375 34.254 35.1421 34.6916 34.7275C35.1292 34.313 35.375 33.7507 35.375 33.1644V21.4092C35.3749 20.9953 35.2794 20.5864 35.0952 20.2111C34.9109 19.8359 34.6424 19.5032 34.3083 19.2365L25.3083 12.0439Z"
        fill="white"
      />
    </svg>
  );
}
